/**
 * How the globe is sized and turned, and how its faint layers look. Shared by
 * the intro, which forms it, and the settled globe, which carries on from
 * where the intro leaves it. Times are seconds after the supernova.
 */
import { smootherstep } from './easing'

const RAD = Math.PI / 180

/* =====================================================================
   TWEAKABLES
   ===================================================================== */
export const R0 = 0.34 /* globe radius as it forms (× min(width, height)) ... */
export const R1 = 0.43 /* ...and after the camera has moved in */
export const DOLLY: readonly [number, number] = [3.4, 6.8] /* when the camera moves closer */
const TILT_DEG = 24 /* north pole tipped towards us */
export const SPIN = 4.5 /* turning speed (deg/s) */
export const LAM_END =
  -32 /* the longitude facing us at DOLLY[1]: the Atlantic, so Czechia, Senegal and Mexico are all in view and East Asia shows through from behind (deg) */
export const LAND_IN: readonly [number, number] = [
  1.4, 3.0,
] /* when the land comes up (the look of it: src/renderer/layers.ts) */
export const TOWN_GLOW = 0.8 /* the faint layer of all 5,764 towns under the particles */
export const METRO_GLOW = 0.3 /* soft glow round the largest agglomerations */
/* ===================================================================== */

/** The north pole's tilt towards us (rad). */
export const TILT = TILT_DEG * RAD

/** The longitude facing us `tau` seconds after the supernova (rad). */
export function longitudeAt(tau: number): number {
  return (LAM_END - SPIN * (tau - DOLLY[1])) * RAD
}

/** The globe's radius `tau` seconds after the supernova (× min(width, height)). */
export function radiusAt(tau: number): number {
  return R0 + (R1 - R0) * smootherstep(DOLLY[0], DOLLY[1], tau)
}
